import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useCanonical = (path?: string) => {
  const location = useLocation();
  
  useEffect(() => {
    // Remove any existing canonical tags
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    // Create new canonical tag
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `https://taxyukti.com${path || location.pathname}`;
    
    // Add to head
    document.head.appendChild(canonical);
    
    // Cleanup function
    return () => {
      if (canonical.parentNode) {
        canonical.parentNode.removeChild(canonical);
      }
    };
  }, [location.pathname, path]);
};
